"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultClientMetricsService = void 0;
const config_1 = __importDefault(require("next/config"));
const art_metrics_1 = __importStar(require("@amzn/art-metrics"));
const constants_1 = require("../../../constants");
const window_1 = require("../../../utils/window");
const katal_1 = require("./katal");
const regionNames = {
    'eu-west-1': 'EUAmazon',
    'eu-south-2': 'EUAmazon',
    'eu-central-1': 'EUAmazon',
    'us-east-1': 'NAAmazon',
    'us-west-2': 'FEAmazon'
};
const createArtMetrics = (isOneBox) => {
    const config = (0, config_1.default)();
    let envStage = constants_1.ENV_STAGE;
    let envRegion = constants_1.ENV_REGION;
    if ((0, window_1.isClientSide)() && config) {
        const { publicRuntimeConfig } = config;
        envStage = publicRuntimeConfig.envStage;
        envRegion = publicRuntimeConfig.envRegion;
    }
    const serviceName = isOneBox ? `${constants_1.SERVICE_NAME_PREFIX}-${envStage}-OneBox` : `${constants_1.SERVICE_NAME_PREFIX}-${envStage}`;
    return art_metrics_1.default.create({
        client: {
            config: {
                serviceName,
                domain: envStage,
                realm: regionNames[envRegion],
                site: constants_1.SITE
            },
            provider(config) {
                return art_metrics_1.default.createProviderByName(art_metrics_1.ClientProviderNames.KATAL, config);
            }
        },
        server: {
            config: {
                serviceName,
                domain: envStage,
                realm: regionNames[envRegion],
                site: constants_1.SITE
            },
            provider(config) {
                return (0, katal_1.fetchKatalServerProvider)(config);
            }
        }
    });
};
const getDefaultClientMetricsService = (isOneBox = false) => createArtMetrics(isOneBox);
exports.getDefaultClientMetricsService = getDefaultClientMetricsService;
